<template>
  <div class="result-config-container">
    <div class="result-inputs">
      {{ resultCode }}
      <PVSelect
        v-model="resultType"
        :options="checkResultsSchema.possibleValues"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref, computed, watch } from 'vue';
  import { CheckResultsConfigSchema } from 'types';

  const props = defineProps<{
    checkResultsSchema: CheckResultsConfigSchema;
    resultCode: string;
    modelValue?: string | null;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', payload: string | null): void;
  }>();

  const resultType = ref<string | null>(null);

  const defaultResult = computed(() => {
    return (
      props.checkResultsSchema.defaultResults?.find(
        (result) => result.resultCode === props.resultCode,
      )?.status ?? null
    );
  });

  watch(
    () => props.modelValue,
    (newValue) => {
      resultType.value = newValue ?? defaultResult.value;
    },
    { immediate: true },
  );

  watch(
    resultType,
    () => {
      emit('update:modelValue', resultType.value);
    },
    { immediate: true },
  );
</script>

<style lang="scss" scoped>
  .result-config-container {
    display: flex;
    column-gap: 1rem;

    .result-inputs {
      display: flex;
      flex-direction: column;
      row-gap: 1rem;
    }
  }
</style>
